/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.27",
    versionName: "0.3.0-nightly.2026.5.27",
    versionChannel: "nightly",
    buildDate: "2026-05-27T00:37:04.077Z",
    commitHash: "5e2bf22a602d939b85865ac58822f8078251e588",
};
